var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.init)?_c('div',[_c('MarktimePreviewTable',{attrs:{"user":_vm.user,"marktime":_vm.marktime,"approvalUser":_vm.approvalUser}})],1):_c('div',{staticClass:"loader loader-dark loader-big ml-4 mt-4 mr-0 mb-0"})])}
var staticRenderFns = []

export { render, staticRenderFns }